module.exports = __webpack_public_path__ + "static/media/REX-Amsterdam.20466aa0.pdf";